import {
    apiRequest,
    kriteriaSkpTunkinCreate
} from "../../../../../services/adapters/kepegawaian/kriteriaSkpTunkinService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", kriteriaSkpTunkinCreate, {
            body: query
        }, true)
    }
}

export default CreateRepository